<template>
  <div>
    <img :src="iconImageSource" v-if="iconImageSource" />
  </div>
</template>

<script>
import Stash from '../stash';

export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },

  computed: {
    iconImageSource() {
      let source = Stash.getCustomIconImageForOrderSource(this.order.source);

      if (source) {
        return source;
      }

      if (this.order.source === 'kiosk') {
        return require('../assets/images/icon-source-mobile.svg');
      }

      return require('../assets/images/icon-source-mobile.svg');
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  width: 2.5rem;
  height: 2.5rem;
  display: inline-block;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &.icon-lg {
    width: 3.5rem;
    height: 3.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// OrderIconImage.vue?f423da8a